import React from 'react';
import { Typography, Button } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { IEmptyStateView } from './EmptyStateView.models';

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      margin: 'auto',
      marginTop: 50,
      marginBottom: theme.spacing(6),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(3),
      },
    },
    image: {
      width: 170,
      height: 155,
    },
    title: {
      fontSize: 17,
      lineHeight: '29px',
      fontWeight: 700,
      textAlign: 'center',
      marginTop: 30,
    },
    description: {
      fontSize: 15,
      textAlign: 'center',
      marginTop: 15,
      marginBottom: 30,
    },
    button: {
      width: 132,
      maxWidth: 200,
      height: 35,
    },
  }),
  { name: 'EmptyStateView' },
);

export const EmptyStateView = ({
  imgSrc,
  imgAlt = '',
  title,
  description,
  action,
  onAction,
}: IEmptyStateView) => {
  const { classes } = useStyles();
  return (
    <div className={classes.wrapper}>
      <img className={classes.image} src={imgSrc} alt={imgAlt} />
      <Typography variant="h2" className={classes.title}>
        {title}
      </Typography>
      {description && (
        <Typography variant="h5" className={classes.description}>
          {description}
        </Typography>
      )}
      {action?.name && (
        <Button
          onClick={onAction}
          startIcon={action?.icon}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          {action.name}
        </Button>
      )}
    </div>
  );
};
